<template>
  <v-row>
    <v-col cols="12">
      <ChangePrimaryDomainForm />
    </v-col>
    <v-col cols="12">
      <ChangeInstructions />
    </v-col>
  </v-row>
</template>

<script>
import ChangePrimaryDomainForm from '@/components/Services/Hosting/Shared/Domains/ChangePrimary/ChangePrimaryDomainForm'
import ChangeInstructions from '@/components/Services/Hosting/Shared/Domains/ChangePrimary/ChangeInstructions'

export default {
  name: 'ChangePrimaryDomainView',
  components: {
    ChangePrimaryDomainForm,
    ChangeInstructions
  },
  data () {
    return {}
  }
}
</script>
